import React, { useEffect, lazy } from 'react';
import {
  // useDispatch,
  useSelector,
} from 'react-redux';
import {
  Route,
  Routes,
  // useNavigate,
} from 'react-router-dom';

// import AffiliatedDentistReferrals from './dentists/referrals/AffiliatedDentistReferrals';

const PageNotFound = lazy(() => import('@components/error/404/PageNotFound'));

const ClinicsPage = lazy(() => import('@shared/layout/dashboard/components/clinics/ClinicsPage'));
const DentistPage = lazy(() => import('@shared/layout/dashboard/components/dentists/DentistsPage'));
const HomePage = lazy(() => import('@shared/layout/dashboard/components/home/HomePage'));
const LabOrdersPage = lazy(() => import('@shared/layout/dashboard/components/lab-orders/LabOrdersPage'));
const LaboratoryPage = lazy(() => import('@shared/layout/dashboard/components/labs/LaboratoryPage'));
const ProfilePage = lazy(() => import('@shared/layout/dashboard/components/profile-page/ProfilePage'));
const ReferralsPage = lazy(() => import('@shared/layout/dashboard/components/referrals/ReferralsPage'));
const SendReferralOrderPage = lazy(() => import('@shared/layout/dashboard/components/send-referral-order/SendReferralOrderPage'));
const TopDentistsCustomersPage = lazy(() => import('@shared/layout/dashboard/components/top-dentists-customers/TopDentistsCustomersPage'));

const DentistListPage = lazy(() => import('./dentists/DentistListPage'));

const ClinicRouter = () => {
  // const dispatch = useDispatch<any>();
  const userDetails = useSelector(({ Auth }) => Auth.user);
  const hasRedirected = useSelector(({ Dashboard }) => Dashboard.hasRedirectToPackages);
  // const navigate = useNavigate();

  useEffect(() => {
    // Check if user has no subscription and hasn't been redirected yet to packages
    if (!userDetails?.subscription?.id && !hasRedirected) {
      // temporary disable redirect to packages
      // dispatch(setHasRedirectToPackagesDispatch(true));
      // navigate('/packages-pricing');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ userDetails, hasRedirected ]);

  return (
    <Routes>
      <Route path="lab-orders/:status" element={<LabOrdersPage />} />
      <Route path="profile/:id/affiliated-dentists" element={<DentistPage />} />
      <Route path="profile/:id" element={<ProfilePage />} />
      <Route path="view/:id/:type" element={<SendReferralOrderPage />} />
      <Route path="send/:type" element={<SendReferralOrderPage />} />
      <Route path="labs" element={<LaboratoryPage />} />
      <Route path="clinics" element={<ClinicsPage />} />
      {/* <Route path="referrals/:status/:id" element={<AffiliatedDentistReferrals />} /> */}
      <Route path="my-dentists/:tab" element={<DentistListPage />} />
      <Route path="dentists" element={<DentistPage />} />
      <Route path="referrals/:status" element={<ReferralsPage />} />
      <Route path="top-dentists" element={<TopDentistsCustomersPage />} />
      <Route index element={<HomePage />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default ClinicRouter;
